const Footer = () => {
	return (
		<footer>
			<span>Developed by </span>
			<a href="https://www.omarkraidie.com/" target="_blank" rel="noopener noreferrer">
				Omar Kraidié
			</a>
		</footer>
	);
};

export default Footer;
